
 define('modules/application/wizard/classes/scenariosCommands',[
  "app",

  // Libs
  "backbone",

  // Classes
  "./genericCollectionSection"

],

function(app, Backbone, genericCollectionSection) {
  var eventsToBind          = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
  var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
    View  : genericCollectionSection.genericCollectionItem.View.extend({
      tagName   : "li",
      className : "scenariosCommands",
      template  : "application/wizard/sections/genericCollectionSection/advancedCommand",
      events    : _.extend(eventsToBind, {
        "click"                            :  "itemClickedEventHandler",
        "change .type"                     :  "typeChangedEventHandler",
        "change .accessory"                :  "accessoryChangedEventHandler",
        "keyup input[name='description']"  :  "descriptionChangedEventHandler"
      }),

      serialize                         : function()  {
        return {model:this.model, app:app};
      },

      initialize                        : function()  {
        this.model.bind("render:requested",   this.render, this);
        this.model.bind("updateViews",        this.render, this);
        this.model.bind("change:number",      this.render, this);
        this.model.bind("product:fetched",    this.render, this);
        this.model.bind("product:fetching",   this.showLoader, this);
      },

      showLoader                      : function() {
        this.$el.find(".regularSection").hide();
        this.$el.find(".loadingSection").show();
      },

      itemClickedEventHandler           : function() {
        this.model.set("selected", true);
      },

      typeChangedEventHandler           : function(e) {
        var typePackageClassId      = e.currentTarget.value;

        //Update the model
        this.model.setPackage(typePackageClassId);
      },

      accessoryChangedEventHandler      : function(e)  {
        if (e.currentTarget.value)
        {
          var accessoryPackageClassId = e.currentTarget.value;

          //Update the model
          this.model.setAccessory(accessoryPackageClassId);
        }
      },

      descriptionChangedEventHandler    : function(e) {
        this.model.set("description", e.currentTarget.value);
      },

      afterRender                       : function()  {
        this.$el.find("select").removeAttr("rel");
        window.customizeFormElements.call();

      }
    }),
    Model : genericCollectionSection.genericCollectionItem.Model.extend({
      defaults : {
        number      : -1,
        filterId    : -1,
        selected    : false,
        description : ""
      },

      initialize                        : function() {
        var fetchedPackages              = this.get("fetchedPackages"),
            fetchedAccessories           = this.get("fetchedAccessories"),
            accessory                    = this.get("accessory"),
            packageClassId               = this.get("packageClassId"),
            accessoryPackageClassId      = this.get("accessoryPackageClassId");

        this.bind("change:selected",          this.selectedStatusChangedEventHandler, this);

        this.unbind("change:packageClassId",  this.addPackageDetails);
        this.bind("change:packageClassId",    this.addPackageDetails, this);

        this.unbind("change:accessory",       this.addAccessoryDetails);
        this.bind("change:accessory",         this.addAccessoryDetails, this);

        this.bind("product:fetched",          this.renderPackage,     this);
        this.bind("accessory:fetched",        this.renderAccessory,   this);

        if (!packageClassId)
          this.setPackage(fetchedPackages[0].packageClassId);
        else
          this.setPackage(packageClassId);

        if (accessoryPackageClassId)
          this.setAccessory(accessoryPackageClassId);
      },

      addPackageDetails : function()  {
        var fetchedPackages         = this.get("fetchedPackages"),
            fetchedAccessories      = this.get("fetchedAccessories"),
            selectedPackageClassId  = this.get("packageClassId"),
            selectedPackages        = _.filter(fetchedPackages, function(iterablePackage) {
              return  iterablePackage.packageClassId === selectedPackageClassId;
            }),
            selectedPackage         = selectedPackages.length>0 ? selectedPackages[0] : undefined;

        this.fetchProduct(selectedPackage);

        if (selectedPackage.specialVars.gotAccessories)
        {
          this.setAccessory(fetchedAccessories[0].packageClassId);
        }
        else
          this.setAccessory(undefined);
      },

      addAccessoryDetails : function()  {
        var fetchedAccessories      = this.get("fetchedAccessories"),
            accessory               = this.get("accessory");

        if (accessory)
        {
          var selectedPackageClassId  = this.get("accessory").packageClassId,
              selectedPackages        = _.filter(fetchedAccessories, function(iterablePackage) {
                return  iterablePackage.packageClassId === selectedPackageClassId;
              }),
              selectedPackage         = selectedPackages.length>0 ? selectedPackages[0] : undefined;

          this.fetchProduct(selectedPackage, true);
        }
      },

      renderPackage     : function(packageToRender)  {
        if (packageToRender)
          _.extend(this.attributes, packageToRender);

        this.trigger("render:requested");
      },

      renderAccessory  : function(packageToRender)  {
        if (packageToRender)
          _.extend(this.attributes.accessory, packageToRender);

        this.trigger("render:requested");
      },

      selectedStatusChangedEventHandler : function() {
        if (this.get("selected"))
          this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
        this.trigger("render:requested");
      },

      fetchProduct                    : function(packageToValorize, _isAccessory) {
        var that                = this,
            isAccessory         = false,
            fetchedAccessories  = this.get("fetchedAccessories");

        if(_isAccessory)
          isAccessory = _isAccessory;

        if (!packageToValorize.isPopulated)
        {
          if (!isAccessory)
            this.trigger("product:fetching");

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageToValorize.packageClassId, function(data){
            var mainProduct       = _.filter(data.products,function(product)    {return (product.mnemonic===1);})[0];
            var secondaryProducts = _.filter(data.products,function(product)    {return (product.mnemonic!==1);});

            _.extend(packageToValorize, mainProduct);
            packageToValorize.secondaryProducts = secondaryProducts;
            packageToValorize.isPopulated       = true;

            if (!isAccessory)
              that.trigger("product:fetched", packageToValorize);
            else
              that.trigger("accessory:fetched", packageToValorize);

          });
        }
        else
        {
          if (!isAccessory)
            this.trigger("product:fetched", packageToValorize);
          else
            that.trigger("accessory:fetched", packageToValorize);
        }
      },

      setPackage            : function(packageClassId) {
        var fetchedAccessories = this.get("fetchedAccessories"),
            choosenPackage     = _.filter(this.get("fetchedPackages"), function(iterablePackage){return iterablePackage.packageClassId===packageClassId;})[0];

        this.set(choosenPackage);
        this.addPackageDetails();
      },

      setAccessory          : function(packageClassId) {
        var accessoryToSet;
        if (packageClassId)
        {
          accessoryToSet = _.filter(this.get("fetchedAccessories"), function(iterablePackage){return iterablePackage.packageClassId===packageClassId;})[0];
          this.set("accessory", accessoryToSet);
        }
        else
          this.set("accessory", undefined);
      },

      enableChangeMode      : function() {
        this.set("changeMode", true);
        this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:granted",   this.completeTypeChange,  this);
        this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:refused",   this.revertTypeChange,    this);
      },

      disableChangeMode     : function() {
        this.set("changeMode", false);
        this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:granted",   this.completeTypeChange);
        this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:refused",   this.revertTypeChange);
      },

      completeTypeChange                : function(packageAttributes) {
        this.set(packageAttributes);
        this.set("futureBonusVde", undefined);
        this.disableChangeMode();
        window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        this.trigger("render:requested");
      },

      revertTypeChange                  : function(packageAttributes) {
        this.set("futureBonusVde", undefined);
        this.disableChangeMode();
        alert("Unable to continue");
        this.trigger("render:requested");
      },

      resetValues                       : function() {
        this.set("catalogId",                undefined);
        this.set("description",              undefined);
        this.set("image",                    undefined);
        this.set("links",                    undefined);
        this.set("mnemonic",                 undefined);
        this.set("optionalPackages",         undefined);
        this.set("packageActuator",          undefined);
        this.set("packageClassId",           undefined);
        this.set("packageClassLabel",        undefined);
        this.set("packageInDepth",           undefined);
        this.set("packageLoad",              undefined);
        this.set("price",                    undefined);
        this.set("productCode",              undefined);
        this.set("productDescription",       undefined);
        this.set("productInDepth",           undefined);
        this.set("productLabel",             undefined);
        this.set("specialVars",              undefined);
        this.set("wizardChoiceDescription",  undefined);
        this.set("wizardChoiceLabel",        undefined);
        this.set("packageClassDescription", undefined);
        this.set("packageClassId",          undefined);
        this.set("packageClassLabel",       undefined);
      },

      deliverCurrent                  : function() {
        var mainProductSpecialVars,
            accessorySpecialVars;

        //Helper method for consumption send
        var sendConsumption        = function(consumption) {
          if (consumption)
          {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

            if (consumption<0)
            {
              consumptionIndicatorModel.addConversationSupplyCurrent(consumption);
              consumptionIndicatorModel.addSoundDiffusionSupplyCurrent(consumption);
            }
            else
            {
              consumptionIndicatorModel.addConversationCurrentConsumption(consumption);
              consumptionIndicatorModel.addSoundDiffusionCurrentConsumption(consumption);
            }
          }
        };

        if (this.get("specialVars"))
        {

          //Converting specialVars to object if necessary
          if (!(this.get("specialVars") instanceof Object))
            this.attributes.specialVars = JSON.parse(this.attributes.specialVars);

          //Retrieving extreConsumption to the relative group if needed
          if ( (this.get("specialVars").consumptionGroupId) && (this.get("specialVars").groupExtraConsumption) )
          {

            var consumptionGroupId        = this.get("specialVars").consumptionGroupId.toString();
            var groupExtraConsumption     = this.get("specialVars").groupExtraConsumption;
            var maxExtraConsumptions      = BticinoS4B.Instances.Models.ApplicationModel.get("maxExtraConsumption");

            //If there's no maxExtraConsumption or the current extraConsumption is greater than maxExtraConsumption for this group
            if ( (!maxExtraConsumptions[consumptionGroupId]) || (maxExtraConsumptions[consumptionGroupId]<groupExtraConsumption) )
              maxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

            BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", maxExtraConsumptions);
          }

          //Sending regular consumption to the consumptionIndicator
          if(this.get("specialVars").currentConsumption)
            sendConsumption(this.get("specialVars").currentConsumption);
        }

        //Sending accessories consumption
        if ( this.get("accessory") && this.get("accessory").specialVars)
        {
          //Converting specialVars to object if necessary
          if (!(this.get("accessory").specialVars instanceof Object))
            this.attributes.accessory.specialVars = JSON.parse(this.attributes.accessory.specialVars);

          if(this.get("accessory").specialVars.currentConsumption)
            sendConsumption(this.get("accessory").specialVars.currentConsumption);
        }
      }
    })
  });

  var collectionItemModel = genericCollectionItem.Model;
  var collectionModel     = Backbone.Collection.extend({model : collectionItemModel});

  var scenariosCommands           = _.extend({}, genericCollectionSection, {

    Views : {
      titleBar  : genericCollectionSection.Views.titleBar,
      content   : genericCollectionSection.Views.content.extend({
        template : "application/wizard/sections/genericCollectionSection/collectionWithInfo",
        events   : _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
          "click .toggleInfoButton" : "toggleInfos"
        }),
        initialize                      : function() {
          genericCollectionSection.Views.content.prototype.initialize.apply(this);

          //Binding events
          window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen",  this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen",    this.accessoryLineChosenEventHandler, this);

          this.model.unbind("packages:fetched",               this.packagesFetchedEventHandler);
          this.model.bind("packages:fetched",                 this.packagesFetchedEventHandler, this);
          this.model.bind("updateViews",                      this.render, this);
        },

        toggleInfos : function(e) {
          return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
        },

        packagesFetchedEventHandler     : function() {
          this.$el.find(".loadingSection").hide();
          this.$el.find(".regularSection").show();
          this.render();
        },

        showLoader                      : function() {
          this.$el.find(".regularSection").hide();
          this.$el.find(".loadingSection").show();
        },

        //Event handlers
        accessoryLineChosenEventHandler : function(accessoryLineId) {
          this.showLoader();
          this.model.fetchPackages();
        },

        addItemButtonClickedEventHandler       : function() {
          var collectionItemView  = genericCollectionItem.View;
          var elementToAdd        = this.model.addItem();
          if (elementToAdd) {
            var viewToAdd = new collectionItemView({model : elementToAdd});
            //this.insertView(".elements", viewToAdd);
            this.model.sortItems();
            this.$el.find(".alert").remove();
            viewToAdd.render();
          }
        },

        duplicateItemButtonClickedEventHandler : function() {
          var collectionItemView  = genericCollectionItem.View;
          var elementToAdd        = this.model.duplicateSelectedItem();
          if (elementToAdd) {
            var viewToAdd = new collectionItemView({model : elementToAdd});
            //this.insertView(".elements", viewToAdd);
            this.model.sortItems();
            this.$el.find(".alert").remove();
            viewToAdd.render();
          }
        },

        removeItemButtonClickedEventHandler    : function() {
          var elementToRemove     = this.model.removeSelectedItem();
          var viewToRemove        = this.getView(function(view){return (elementToRemove===view.model);});
          if (viewToRemove) {
            viewToRemove.$el.remove();
            this.model.sortItems();
          }
        },

        beforeRender                           : function() {
          var collection          = this.model.get("collection"),
              collectionLength    = collection.models ? collection.models.length : 0,
              collectionItemView  = genericCollectionItem.View,
              i                   = 0;

          for (i=0; i<collectionLength; i++)
            this.insertView(".elements", new collectionItemView({model : collection.models[i]}));
        },

        afterRender                            : function() {
          window.customizeFormElements.call();
        }

      })
    },

    Model                         : genericCollectionSection.Model.extend({
      defaults : _.extend(  {
        name                   : "IDS_WAM8_32",
        collectionEventAggregator : _.extend({}, Backbone.Events),
        accessoriesIdWizardChoice:"829",
        infoQuote : "IDS_WGENTT_000045"
      }, genericCollectionSection.Model.prototype.defaults),

      initialize        : function()  {
        genericCollectionSection.Model.prototype.initialize.apply(this);


        //Bindings
        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",   this.deliverModel, this);

        this.get("collectionEventAggregator").unbind("selectedItem:changed", this.selectedItemChangedEventHandler);
        this.get("collectionEventAggregator").bind("selectedItem:changed",   this.selectedItemChangedEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",   this.loadProject, this);

        //Checking if there's already an accessory line
        var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

        if (this.get("collection"))
        {
          oldCollection  = this.get("collection");

          if (oldCollection.models)
            oldCollection = oldCollection.models;
        }

        if (accessoryLineId && accessoryLineId!==0)
        {
          this.fetchPackages();
          this.fetchAccessories();
        }
        else
          window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", function() {
            this.fetchPackages();
            this.fetchAccessories();
          }, this);

        this.set("collection", new collectionModel());
        collection      = this.get("collection");

        if (oldCollection)
        {
          for (i=0; i<oldCollection.length; i++)
          {
            if (!oldCollection[i].attributes)
              this.addItem(_.extend({
                collectionEventAggregator : this.get("collectionEventAggregator"),
                fetchedPackages        : this.get("fetchedPackages"),
                fetchedAccessories     : this.get("fetchedAccessories")
              }, oldCollection[i]));
            else
              collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
          }
        }
      },

      fetchPackages   : function()  {
        this.trigger("packages:fetching");
        var that                                    = this,
            //Defining race conditions variables
            powerSupplyDataFetchCompleted           = false,
            accessoryDataFetchCompleted             = false,
            i                                       = 0;

        //Race condition check
        var checkRaceCondition                      = function() {
          if( powerSupplyDataFetchCompleted)
            that.trigger("packages:fetched");
        };

        //Defining success callbacks
        var powerSupplyPackageFetchSuccessCallback  = function(data) {
          var fetchedPackages       = data.packages,
              fetchedPackagesLength = fetchedPackages.length;

          for ( i=0; i<fetchedPackagesLength; i++ )
          {
            if  ( fetchedPackages[i].specialVars  &&  fetchedPackages[i].specialVars!==""  &&  typeof(fetchedPackages[i].specialVars)!=="object" )
              fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);
          }

          that.attributes.fetchedPackages    = fetchedPackages;
          powerSupplyDataFetchCompleted      = true;
          checkRaceCondition();
        };

        //Defining success callbacks
        var accessoryPackageFetchSuccessCallback    = function(data) {
          var fetchedAccessories       = data.packages,
              fetchedAccessoriesLength = fetchedAccessories.length;

          for ( i=0; i<fetchedAccessoriesLength; i++ )
          {
            if  ( fetchedAccessories[i].specialVars  &&  fetchedAccessories[i].specialVars!==""  &&  typeof(fetchedAccessories[i].specialVars)!=="object" )
              fetchedAccessories[i].specialVars = JSON.parse(fetchedAccessories[i].specialVars);
          }

          that.attributes.fetchedAccessories= fetchedAccessories;
          accessoryDataFetchCompleted       = true;
          checkRaceCondition();
        };

        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(827, powerSupplyPackageFetchSuccessCallback,  undefined, true);
      },

      fetchAccessories                  : function() {
        var that = this,
            fetchedAccessories;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(that.get("accessoriesIdWizardChoice"), function(data) {
          var accessoriesLength = data.packages.length;
          for (i=0; i<accessoriesLength; i++)
            data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);

          fetchedAccessories = data.packages;
        });
        this.set("fetchedAccessories", fetchedAccessories);

      },

      addItem                         : function(itemModel) {
        var collection                 = this.get("collection"), collectionLength = collection.length;
        var defaultItem;

        var collectionItemModel = genericCollectionItem.Model;

        if (itemModel)
          defaultItem         = new collectionItemModel(_.extend({fetchedPackages : this.get("fetchedPackages"), fetchedAccessories : this.get("fetchedAccessories"), number : this.getNewNumber(), collectionEventAggregator : this.get("collectionEventAggregator")}, itemModel));
        else
          defaultItem         = new collectionItemModel({fetchedPackages : this.get("fetchedPackages"), fetchedAccessories : this.get("fetchedAccessories"), number : this.getNewNumber(), collectionEventAggregator : this.get("collectionEventAggregator")});

        var itemsToAdd        = [];
        itemsToAdd.push(defaultItem);
        if (genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd))
        {
          defaultItem.set("selected", true);
          this.trigger("updateViews", this.get("collection").length);

          //Trigger event for zone validation
          this.trigger("item:added");

          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          this.sortItems();
          return defaultItem;
        }
      },

      duplicateItem           : function(modelToDuplicate) {
        var collectionItemModel        = genericCollectionItem.Model;
        var itemNumber                 = this.getNewNumber();
        var selectedModels             = this.get("collection").filter(function(item){return item.get("selected");});

        var collection                 = this.get("collection"), collectionLength = collection.length;

        if (modelToDuplicate && collection.length + 1 <= this.get("maxItem"))
        {
          modelToDuplicate = new collectionItemModel(modelToDuplicate.attributes);
          if (modelToDuplicate)
          {
            modelToDuplicate.set("number", itemNumber);
            this.get("collection").add(modelToDuplicate);
            this.trigger("updateViews", this.get("collection").length);

            //Trigger event for zone validation
            this.trigger("item:added");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.sortItems();
            return modelToDuplicate;
          }
          else
            return false;
        }
        else
        {
          alert($.i18n._('IDS_W1_9128'));
          return false;
        }
      },

      removeItem: function(modelToRemove, _silent) {
        var silent = false;

        if (_silent)
          silent = _silent;

        if (!modelToRemove.get("partOfKit") || silent) {
          if (this.deleteItem(modelToRemove, silent)) {
            this.trigger("updateViews", this.get("collection").length);

            this.sortItems();

            //Trigger event for zone validation
            this.trigger("item:removed");
            this.trigger("render:requested");

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.sortItems();
            return modelToRemove;
          }
        } else{
            alert($.i18n._('IDS_W1_9191'));
            return false;
          }
      },

      sortItems                       : function() {
        var collection = this.get("collection"), collectionLength = collection.models ? collection.models.length : 0;
        var i=0;

        for (i=0; i<collectionLength; i++)
        {
          collection.models[i].set("number", (i+1));
          if (i===(collectionLength-1))
            collection.models[i].set("selected", true);
          else
            collection.models[i].set("selected", false);
        }
      },

      deliverCurrent  : function()  {
        var collection                  = this.get("collection"), collectionLength = collection.length;
        var consumptionIndicatorModel   = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
        var extraConsumption            = 30; //30 mA of extra consumption
        var mustDeliverExtraConsumption = false;
        var i=0;

        //Delivering regular consumptions
        for (i=0; i<collectionLength; i++)
          collection.models[i].deliverCurrent();
      },

      deliverModel   : function() {
        switch(BticinoS4B.vars.system.id)
        {
        case '#2':
          BticinoS4B.solution.thermoregulation.scenariosCommands = this;
          break;
        case '#4':
          BticinoS4B.solution.intrusionDetection.scenariosCommands = this;
          break;
        case '#5+6':
          BticinoS4B.solution.audioVideo.scenariosCommands = this;
          break;
        case '#13+20':
          BticinoS4B.solution.automation.scenariosCommands = this;
          break;
        case '#13':
          BticinoS4B.solution.automationSimple.scenariosCommands = this;
          break;
        case '#21':
          BticinoS4B.solution.energyManagement.scenariosCommands = this;
          break;                    
        };
        BticinoS4B.Instances.Models.ApplicationModel.set("scenariosCommands", this);

        var dataProvider      = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            collection        = this.get("collection"),
            collectionLength  = collection.models ? collection.models.length : 0,
            toReturn          = [],
            i                 = 0,
            j                 = 0;

        for(i=0; i<collectionLength; i++)
        {

          toReturn.push({
            productCode       : collection.models[i].get("productCode"),
            productLabel      : collection.models[i].get("productLabel"),
            packageClassLabel : collection.models[i].get("packageClassLabel"),
            packageClassId    : collection.models[i].get("packageClassId"),
            kitValue          : collection.models[i].get("kitValue"),
            partOfKit         : collection.models[i].get("partOfKit"),
            quantity          : 1,
            price             : collection.models[i].get("price")
          });

          if (collection.models[i].get("secondaryProducts"))
          {
            for (j = collection.models[i].length - 1; j >= 0; j--) {
              toReturn.push({
                productCode       : collection.models[i].get("secondaryProducts")[j].productCode,
                productLabel      : collection.models[i].get("secondaryProducts")[j].productLabel,
                packageClassLabel : collection.models[i].get("secondaryProducts")[j].packageClassLabel,
                packageClassId    : collection.models[i].get("secondaryProducts")[j].packageClassId,
                kitValue          : collection.models[i].get("kitValue"),
                partOfKit         : collection.models[i].get("partOfKit"),
                quantity          : 1,
                price             : collection.models[i].get("secondaryProducts")[j].price
              });
            }
          }

          if (collection.models[i].get("accessory"))
          {
            toReturn.push({
              productCode       : collection.models[i].get("accessory").productCode,
              productLabel      : collection.models[i].get("accessory").productLabel,
              packageClassLabel : collection.models[i].get("accessory").packageClassLabel,
              packageClassId    : collection.models[i].get("accessory").packageClassId,
              kitValue          : collection.models[i].get("accessory").kitValue,
              partOfKit         : collection.models[i].get("accessory").partOfKit,
              quantity          : 1,
              price             : collection.models[i].get("accessory").price
            });
          }
        }

        return toReturn;
      },

      loadProject : function(project){
        var that = this,
            oldCollection,
            i = 0,
            load = function() {
              if (that.get("collection")) {
                oldCollection = that.get("collection");
                if (oldCollection.models) oldCollection = oldCollection.models;
              }

              that.set("collection", new collectionModel());
              collection = that.get("collection");

              if (oldCollection) {
                for (i = 0; i < oldCollection.length; i++) {
                  if (!oldCollection[i].attributes)
                    that.addItem(_.extend({
                      collectionEventAggregator: that.get("collectionEventAggregator")
                    }, oldCollection[i]));
                  else
                    collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
                }
                that.set("collection", collection);
                that.get("collectionEventAggregator").trigger("updateGlobalLengths");
                that.trigger("updateViews");
                window.BticinoS4B.eventAggregator.trigger("modelDeliver:request");
              }
            };

        if (project.integrationAndControl && project.integrationAndControl.scenariosCommandsModel)
          this.set("collection", project.integrationAndControl.scenariosCommandsModel.collection);

        if (!this.get("fetchedPackages"))
          this.bind("packages:fetched", load);
        else
          load();
      }
    }),
    genericCollectionItem   : genericCollectionItem
  });

  // Required, return the module for AMD compliance
  return scenariosCommands;

});